import RoomSettings from './room-settings'

export default RoomSettings
